var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActionsCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#323657",
    d: "M15.188 2.25h-9a.563.563 0 0 0-.563.563v2.812H2.813a.563.563 0 0 0-.563.563v9a.56.56 0 0 0 .563.562h9a.56.56 0 0 0 .562-.562v-2.813h2.813a.56.56 0 0 0 .562-.562v-9a.563.563 0 0 0-.562-.563M11.25 14.625H3.375V6.75h7.875zm3.375-3.375h-2.25V6.188a.563.563 0 0 0-.562-.563H6.75v-2.25h7.875z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionsCopy);
export default __webpack_public_path__ + "static/media/actions-copy.5cb3dba0f30a4bc435133c48298aa1b9.svg";
export { ForwardRef as ReactComponent };